const config = {
    showAuthors: false
};

export default config;